import { useEffect, useState } from "react";
import campaignsObj, {
  allCampaignLocations,
} from "../services/campaignsDefinitions";

const useCampaign = () => {
  const getCampaignCode = (pathname) => {
    const parts = pathname.split("/");

    if (parts.length > 2 && parts[1] === "campaigns") {
      return parts[2];
    }

    return null;
  };
  const getCampaignSubpage = (pathname) => {
    const parts = pathname.split("/");

    if (parts.length > 3 && parts[1] === "campaigns") {
      return parts[3];
    }

    return null;
  };

  const [campaignCode, _setCampaignCode] = useState(
    getCampaignCode(window.location.pathname),
  );
  const [subpage, setSubPage] = useState(
    getCampaignSubpage(window.location.pathname),
  );

  const landingPageCampaign =
    campaignsObj[
      campaignCode ||
        (allCampaignLocations.find((l) => l === location.pathname) && "all")
    ];
  const [campaign, setCampaign] = useState(landingPageCampaign);

  const setCampaignCode = (pathname) => {
    _setCampaignCode(getCampaignCode(pathname));
    setSubPage(getCampaignSubpage(pathname));
  };

  useEffect(() => {
    setCampaign(
      campaignsObj[
        campaignCode ||
          (allCampaignLocations.find((l) => l === location.pathname) && "all")
      ],
    );
  }, [campaignCode]);

  return {
    campaign,
    campaignCode,
    subpage,
    setCampaignCode,
  };
};

export default useCampaign;
